#search.vue
<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC000956')"
							paramKey="partNo"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.partNo"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
						</search-input>
					</el-col>
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC000957')"
							paramKey="partNm"
							@commInput="setSearchParam"
							:propData="searchParams.partNm"
						></search-input>
					</el-col>
					<el-col :span="4">
						<select-combo
							:label="getMessage_('MWCC000891')"
							paramKey="useYn"
							:options="useYnList"
							:propData="searchParams.useYn"
							@commChange="setSearchParam"
						></select-combo>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
import partMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {};
	},
	components: { SearchInput, SelectCombo, partMngPopup },
	async created() {
		try {
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' });
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getPartMngList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		sendData(param) {
			this.setSearchParam_({ key: 'partNo', value: param.partNo });
			this.searchList();
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
